module.exports = __webpack_public_path__ + "static/media/btn_huawei.d9e19e6c.svg";